// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"b15c7d9b","246":"95fbdf96","453":"8e9e3179"}[chunkId] + ".chunk.js";
};